export const translations = {
  de: {
    nav: {
      services: "Leistungen",
      projects: "Projekte",
      about: "Über uns",
      contact: "Kontakt",
      cta: "Anfrage senden",
    },
    hero: {
      overline: "Ingenieur- & Architekturbüro — Remote",
      titleA: "Präzision",
      titleB: "im Bau.",
      titleC: "Aus der Ferne.",
      description:
        "ArStudio Solutions liefert Ingenieurleistungen in den Bereichen Bauingenieurwesen, Architektur, TGA- und Elektroplanung — koordiniert, dokumentiert und international einsetzbar.",
      ctaPrimary: "Projekt anfragen",
      ctaSecondary: "Leistungen ansehen",
      stat1Label: "Disziplinen",
      stat1Value: "04",
      stat2Label: "Standort",
      stat2Value: "DE / XK",
      stat3Label: "Modell",
      stat3Value: "REMOTE",
    },
    marquee: [
      "Bauingenieurwesen",
      "Architektur",
      "TGA-Planung",
      "Elektroplanung",
      "Statik",
      "BIM-Koordination",
      "Ausführungsplanung",
    ],
    services: {
      overline: "Leistungen",
      title: "Vier Disziplinen. Ein Team. Weltweit einsetzbar.",
      items: [
        {
          num: "01",
          title: "Bauingenieurwesen",
          desc: "Statik, Tragwerksplanung und Konstruktion für Wohn-, Gewerbe- und Industriebauten. Wir übernehmen die vollständige Konstruktion von Metall- und Stahltragwerken, Bewehrungs- und Schalungsplanung, Betonbau, statische Analysen sowie alle weiteren begleitenden Leistungen.",
          points: [
            "Statik & Tragwerksplanung",
            "Metall- & Stahlkonstruktionen",
            "Bewehrungsplanung (Armierung)",
            "Schalungspläne & Schalungskonzepte",
            "Betonbau & Stahlbetonkonstruktionen",
            "Statische Berechnungen & Analysen",
          ],
        },
        {
          num: "02",
          title: "Architektur",
          desc: "Vom ersten Entwurf bis zur schlüsselfertigen Übergabe. Wir liefern Entwurfs-, Genehmigungs- und Ausführungsplanung, fotorealistische Visualisierungen für Innen- und Außenräume sowie sämtliche Bauzeichnungen.",
          points: [
            "Entwurfs- & Genehmigungsplanung",
            "Ausführungsplanung",
            "3D-Visualisierungen (Innen & Außen)",
            "Innenarchitektur / Interior Design",
            "Fassaden- & Schnittdetails",
            "Grundrisse, Ansichten & Bauzeichnungen",
          ],
        },
        {
          num: "03",
          title: "TGA-Planung",
          desc: "Technische Gebäudeausrüstung von der ersten Berechnung bis zur Ausführungsplanung. Heizung, Lüftung, Sanitär, Klima und Sprinkler — inklusive Energiekonzepten, Lastberechnungen, Rohrnetzen und Gebäudeautomation, alles nach deutschen Normen.",
          points: [
            "Heizung, Lüftung & Klima (HLK)",
            "Sanitär & Sprinkleranlagen",
            "Energiekonzepte & Effizienznachweise",
            "Heiz- & Kühllastberechnung",
            "Rohrleitungs- & Kanalnetzplanung",
            "Regelungstechnik & Gebäudeautomation",
          ],
        },
        {
          num: "04",
          title: "Elektroplanung",
          desc: "Vollständige Elektroplanung für Neubau und Sanierung — von Stark- und Schwachstrom über Beleuchtung, Photovoltaik und Ladeinfrastruktur bis hin zu Brandmelde-, Sicherheits- und Datentechnik.",
          points: [
            "Starkstrom & Verteilung",
            "Schwachstrom & Datentechnik",
            "Beleuchtungsplanung & DIALux",
            "Photovoltaik & E-Mobility",
            "Brandmelde- & Sicherheitstechnik",
            "Blitzschutz, Erdung & Berechnungen",
          ],
        },
      ],
    },
    projects: {
      overline: "Referenzprojekte",
      title: "Ausgewählte Werke",
      viewAll: "Weitere Projekte in Vorbereitung",
      filterLabel: "Filter nach Disziplin",
      filterAll: "Alle",
      disciplines: {
        architektur: "Architektur",
        elektro: "Elektroplanung",
        statik: "Statik & Bauingenieurwesen",
      },
      list: [
        {
          slug: "objekt-komercial-essen",
          discipline: "architektur",
          num: "01",
          year: "2024",
          location: "Essen, Deutschland",
          category: "Gewerbeobjekt · Ausführungsplanung",
          title: "Objekt Komercial — Wellness, Gastronomie, Events",
          role: "Ausführungsplanung & Elektroplanung",
          cta: "Projekt öffnen",
        },
        {
          slug: "moschee-dortmund",
          discipline: "architektur",
          num: "02",
          year: "2025",
          location: "Dortmund, Deutschland",
          category: "Sakralbau · Architektur + Elektro",
          title: "Moschee Dortmund — Fassade, Interior & Elektro",
          role: "Fassadenvisualisierung, Ausführungsplanung, Interior, Details & Elektroplanung",
          cta: "Projekt öffnen",
        },
        {
          slug: "villa-schweiz-pool",
          discipline: "architektur",
          num: "03",
          year: "2025",
          location: "Schweiz",
          category: "Wohnbau · Visualisierung",
          title: "Villa mit Poolterrasse — Visualisierung & Schnitte",
          role: "3D-Visualisierung, Schnitte & Detailplanung für Schweizer Kunden",
          cta: "Projekt öffnen",
        },
        {
          slug: "kindertagesstaette",
          discipline: "elektro",
          num: "04",
          year: "2025",
          location: "Deutschland",
          category: "Bildungsbau · Elektro",
          title: "4-zügige Kindertagesstätte",
          role: "Elektroplanung nach VDE / DIN-Standards",
          cta: "Projekt öffnen",
        },
        {
          slug: "doni-fruits-lagerhalle",
          discipline: "statik",
          num: "05",
          year: "2025",
          location: "Kosovo",
          category: "Lagerhalle · Statik & Metallbau",
          title: "Lagerhalle Doni Fruits — EG + 1. OG",
          role: "Komplette Statik, Metallkonstruktion mit Sandwichpaneelen, Analysen & Bemessungen — geplant durch unseren in Deutschland anerkannten Master-Ingenieur",
          cta: "Projekt öffnen",
        },
      ],
    },
    about: {
      overline: "Über uns",
      title: "Ein Ingenieurbüro ohne Grenzen.",
      p1: "ArStudio Solutions LLC ist ein international tätiges Ingenieurbüro mit Sitz in Ferizaj (Kosovo) unter der Leitung von Arian Isufi. Wir liefern präzise Planungsleistungen vollständig remote — für Bauherren, Generalplaner und Fachplaner in ganz Europa.",
      p2: "Unser Ansatz vereint deutsche Ingenieurpräzision mit einem effizienten, digital-first Arbeitsmodell. Jedes Projekt wird koordiniert, dokumentiert und nach lokalen Normen umgesetzt.",
      pillars: [
        { label: "Gegründet", value: "ArStudio" },
        { label: "Sprachen", value: "DE / EN / SQ" },
        { label: "Reichweite", value: "EU-weit" },
        { label: "Auslieferung", value: "Remote" },
      ],
    },
    contact: {
      overline: "Kontakt",
      title: "Sprechen wir",
      titleAccent: "über Ihr Projekt.",
      description:
        "Beschreiben Sie kurz Ihr Bauvorhaben. Wir melden uns innerhalb von 24 Stunden mit einer ersten Einschätzung.",
      form: {
        name: "Name",
        email: "E-Mail",
        subject: "Betreff",
        message: "Ihre Nachricht",
        submit: "Anfrage senden",
        sending: "Wird gesendet...",
        success: "Vielen Dank! Wir melden uns in Kürze.",
        error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      },
      info: {
        phoneLabel: "Telefon",
        emailLabel: "E-Mail",
        addressLabel: "Adresse",
        hoursLabel: "Verfügbarkeit",
        hoursValue: "Mo — Fr, 09:00 — 18:00 CET",
      },
    },
    footer: {
      cta: "Bereit zu bauen?",
      ctaSub: "Schreiben Sie uns.",
      rights: "Alle Rechte vorbehalten.",
      backTop: "Nach oben",
      imprint: "Impressum",
      privacy: "Datenschutz",
    },
    projectDetail: {
      back: "Zurück",
      overview: "Projektübersicht",
      metaLocation: "Standort",
      metaYear: "Jahr",
      metaScope: "Leistung",
      metaClient: "Rolle",
      metaClientValue: "Arstudio Solutions LLC",
      gallery: "Impressionen",
      details: {
        "objekt-komercial-essen": {
          subtitle: null,
          overviewText:
            "Dieses Projekt wurde in Essen (Deutschland) entwickelt. Es handelt sich um ein gewerbliches Objekt mit gemischter Nutzung: Wellness, Gastronomie und Eventflächen. ArStudio Solutions LLC war als ausführungsplanendes Ingenieurbüro tätig, inklusive der vollständigen Elektroplanung.",
          metaScopeValue: "Ausführungsplanung, Elektroplanung",
          buttons: [
            { key: "plans", icon: "file", label: "Ausführungspläne ansehen", status: "Google Drive", type: "link" },
            { key: "details", icon: "arrow", label: "Projektdetails öffnen", status: "Google Drive", type: "link", primary: true },
            { key: "interior", icon: "sofa", label: "Interior / Innenraum", status: "In Arbeit", type: "disabled" },
            { key: "electrical", icon: "zap", label: "Elektroplanung", status: "In Arbeit", type: "disabled" },
          ],
        },
        kindertagesstaette: {
          subtitle:
            "Neubebauung eines Grundstückes zwecks Unterbringung einer 4-zügigen Kindertagesstätte",
          overviewText:
            "Neubebauung eines Grundstückes zur Errichtung einer 4-zügigen Kindertagesstätte. Die vollständige Elektroplanung wurde nach deutschen Normen (VDE, DIN, DGUV) durchgeführt — von der Verteilung über Beleuchtung, Brandmelde- und Sicherheitstechnik bis hin zu Datennetz und Not-/Sicherheitsbeleuchtung.",
          metaScopeValue: "Elektroplanung (VDE / DIN)",
          buttons: [
            { key: "view", icon: "arrow", label: "Projekt öffnen", status: "Google Drive", type: "link", primary: true },
          ],
        },
        "moschee-dortmund": {
          subtitle:
            "Vollintegrierte Planung — Architektur, Interior und Elektroplanung aus einer Hand",
          overviewText:
            "Ganzheitliches Projekt für die Moschee in Dortmund. ArStudio Solutions LLC hat die vollständige Fassadenvisualisierung und Renderings, Ausführungsplanung, Innenarchitektur, Detail- und Schnittplanung sowie die komplette Elektroplanung intern koordiniert und geliefert — zwei Disziplinen, ein Team.",
          metaScopeValue: "Architektur, Interior & Elektroplanung",
          buttons: [
            { key: "architektur", icon: "file", label: "Architektur öffnen", status: "Google Drive · Fassade, Interior, Details, Schnitte", type: "link", primary: true },
            { key: "elektro", icon: "zap", label: "Elektroplanung öffnen", status: "Google Drive · Elektrik", type: "link" },
          ],
        },
      },
    },
    legal: {
      impressum: {
        title: "Impressum",
        subtitle: "Angaben gemäß § 5 TMG",
        sections: [
          {
            h: "Anbieter",
            body: [
              "ArStudio Solutions LLC",
              "Inhaber: Arian Isufi",
              "Rruga 12 Qershori Nr. 144",
              "70000 Ferizaj, Kosovo",
            ],
          },
          {
            h: "Kontakt",
            body: [
              "Telefon: +383 45 813 843",
              "E-Mail: info@arstudio360.online",
              "Web: arstudio360.online",
            ],
          },
          {
            h: "Verantwortlich für den Inhalt",
            body: [
              "Arian Isufi",
              "Anschrift wie oben",
            ],
          },
          {
            h: "Haftung für Inhalte",
            body: [
              "Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.",
            ],
          },
          {
            h: "Haftung für Links",
            body: [
              "Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.",
            ],
          },
          {
            h: "Urheberrecht",
            body: [
              "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht. Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
            ],
          },
        ],
      },
      privacy: {
        title: "Datenschutzerklärung",
        subtitle: "Informationen zur Verarbeitung Ihrer Daten",
        sections: [
          {
            h: "1. Verantwortliche Stelle",
            body: [
              "Verantwortlich für die Datenverarbeitung auf dieser Website ist:",
              "ArStudio Solutions LLC, Arian Isufi, Rruga 12 Qershori Nr. 144, 70000 Ferizaj, Kosovo. E-Mail: info@arstudio360.online.",
            ],
          },
          {
            h: "2. Erhebung und Speicherung personenbezogener Daten",
            body: [
              "Wenn Sie unser Kontaktformular nutzen, erheben wir folgende Daten: Name, E-Mail-Adresse, Betreff und Nachrichtentext. Diese Daten werden ausschließlich zur Bearbeitung Ihrer Anfrage gespeichert und nicht an Dritte weitergegeben.",
              "Rechtsgrundlage: Art. 6 Abs. 1 lit. b und f DSGVO (Vertragsanbahnung / berechtigtes Interesse).",
            ],
          },
          {
            h: "3. Server-Log-Dateien",
            body: [
              "Der Anbieter der Seite erhebt und speichert automatisch Informationen in Server-Log-Dateien (Browsertyp, verwendetes Betriebssystem, Referrer URL, Hostname des zugreifenden Rechners, Uhrzeit der Serveranfrage). Diese Daten sind nicht bestimmten Personen zuordenbar.",
            ],
          },
          {
            h: "4. Ihre Rechte",
            body: [
              "Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Wenden Sie sich hierzu bitte an: info@arstudio360.online.",
            ],
          },
          {
            h: "5. Speicherdauer",
            body: [
              "Personenbezogene Daten aus Anfragen werden gelöscht, sobald sie für den Zweck ihrer Erhebung nicht mehr erforderlich sind — spätestens nach Ablauf gesetzlicher Aufbewahrungspflichten.",
            ],
          },
          {
            h: "6. Cookies & Analytics",
            body: [
              "Diese Website verwendet ausschließlich technisch notwendige Cookies. Es werden keine Marketing- oder Tracking-Cookies eingesetzt, die eine ausdrückliche Einwilligung erfordern würden.",
            ],
          },
        ],
      },
    },
  },
  en: {
    nav: {
      services: "Services",
      projects: "Projects",
      about: "About",
      contact: "Contact",
      cta: "Send request",
    },
    hero: {
      overline: "Engineering & Architecture — Remote",
      titleA: "Precision",
      titleB: "in construction.",
      titleC: "Delivered remote.",
      description:
        "ArStudio Solutions delivers civil, architectural, MEP and electrical engineering services — coordinated, documented, and internationally deployable.",
      ctaPrimary: "Request a project",
      ctaSecondary: "View services",
      stat1Label: "Disciplines",
      stat1Value: "04",
      stat2Label: "Base",
      stat2Value: "DE / XK",
      stat3Label: "Model",
      stat3Value: "REMOTE",
    },
    marquee: [
      "Civil Engineering",
      "Architecture",
      "MEP Planning",
      "Electrical Planning",
      "Structural",
      "BIM Coordination",
      "Construction Docs",
    ],
    services: {
      overline: "Services",
      title: "Four disciplines. One team. Deployable worldwide.",
      items: [
        {
          num: "01",
          title: "Civil Engineering",
          desc: "Structural design and construction for residential, commercial and industrial buildings. We handle metal & steel structures, reinforcement and formwork planning, concrete construction, static analyses and every supporting task.",
          points: [
            "Structural design",
            "Metal & steel structures",
            "Reinforcement planning",
            "Formwork drawings & concepts",
            "Concrete & reinforced concrete",
            "Static calculations & analysis",
          ],
        },
        {
          num: "02",
          title: "Architecture",
          desc: "Concept, permit and construction planning. From first sketch to turnkey delivery, coordinated across all trades.",
          points: ["Concept design", "Permit filing", "Detail planning"],
        },
        {
          num: "03",
          title: "MEP / TGA",
          desc: "Technical building systems from first calculation to construction documentation. Heating, ventilation, sanitary, HVAC and sprinklers — including energy concepts, load calculations, piping networks and building automation, all to German standards.",
          points: [
            "Heating, ventilation & AC",
            "Sanitary & sprinklers",
            "Energy concepts & proofs",
            "Heating & cooling load calc.",
            "Piping & duct network design",
            "Controls & building automation",
          ],
        },
        {
          num: "04",
          title: "Electrical Planning",
          desc: "Complete electrical design for new-build and refurbishment — from power distribution and low-voltage to lighting, PV, e-mobility and fire/safety systems.",
          points: [
            "Power & distribution",
            "Low-voltage & data",
            "Lighting design & DIALux",
            "Photovoltaic & e-mobility",
            "Fire alarm & safety",
            "Lightning protection & grounding",
          ],
        },
      ],
    },
    projects: {
      overline: "Reference projects",
      title: "Selected work",
      viewAll: "More projects in preparation",
      filterLabel: "Filter by discipline",
      filterAll: "All",
      disciplines: {
        architektur: "Architecture",
        elektro: "Electrical",
        statik: "Structural",
      },
      list: [
        {
          slug: "objekt-komercial-essen",
          discipline: "architektur",
          num: "01",
          year: "2024",
          location: "Essen, Germany",
          category: "Commercial · Construction planning",
          title: "Commercial Object — Wellness, Hospitality, Events",
          role: "Construction planning & electrical",
          cta: "Open project",
        },
        {
          slug: "moschee-dortmund",
          discipline: "architektur",
          num: "02",
          year: "2025",
          location: "Dortmund, Germany",
          category: "Sacred building · Architecture + Electrical",
          title: "Mosque Dortmund — Facade, Interior & Electrical",
          role: "Facade rendering, construction planning, interior, details & electrical",
          cta: "Open project",
        },
        {
          slug: "villa-schweiz-pool",
          discipline: "architektur",
          num: "03",
          year: "2025",
          location: "Switzerland",
          category: "Residential · Visualization",
          title: "Villa with pool terrace — Visualization & sections",
          role: "3D visualization, sections & detail planning for a Swiss client",
          cta: "Open project",
        },
        {
          slug: "kindertagesstaette",
          discipline: "elektro",
          num: "04",
          year: "2025",
          location: "Germany",
          category: "Education · Electrical",
          title: "4-track Kindergarten (Kindertagesstätte)",
          role: "Electrical planning per VDE / DIN standards",
          cta: "Open project",
        },
        {
          slug: "doni-fruits-lagerhalle",
          discipline: "statik",
          num: "05",
          year: "2025",
          location: "Kosovo",
          category: "Warehouse · Structural & Steel",
          title: "Warehouse Doni Fruits — GF + 1st floor",
          role: "Complete structural design, steel construction with sandwich panels, analyses & sizing — by our Germany-recognized master engineer",
          cta: "Open project",
        },
      ],
    },
    about: {
      overline: "About",
      title: "An engineering office without borders.",
      p1: "ArStudio Solutions LLC is an international engineering office based in Ferizaj (Kosovo), led by Arian Isufi. We deliver precise planning services entirely remote — for developers, general planners and specialist consultants across Europe.",
      p2: "Our approach combines German engineering precision with an efficient, digital-first workflow. Every project is coordinated, documented and delivered according to local codes.",
      pillars: [
        { label: "Founded by", value: "ArStudio" },
        { label: "Languages", value: "DE / EN / SQ" },
        { label: "Reach", value: "EU-wide" },
        { label: "Delivery", value: "Remote" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Let's talk",
      titleAccent: "about your project.",
      description:
        "Describe your project in a few lines. We'll get back to you within 24 hours with a first assessment.",
      form: {
        name: "Name",
        email: "Email",
        subject: "Subject",
        message: "Your message",
        submit: "Send request",
        sending: "Sending...",
        success: "Thank you! We'll be in touch shortly.",
        error: "Something went wrong. Please try again.",
      },
      info: {
        phoneLabel: "Phone",
        emailLabel: "Email",
        addressLabel: "Address",
        hoursLabel: "Availability",
        hoursValue: "Mon — Fri, 09:00 — 18:00 CET",
      },
    },
    footer: {
      cta: "Ready to build?",
      ctaSub: "Write to us.",
      rights: "All rights reserved.",
      backTop: "Back to top",
      imprint: "Imprint",
      privacy: "Privacy",
    },
    projectDetail: {
      back: "Back",
      overview: "Project overview",
      metaLocation: "Location",
      metaYear: "Year",
      metaScope: "Scope",
      metaClient: "Role",
      metaClientValue: "Arstudio Solutions LLC",
      gallery: "Impressions",
      details: {
        "objekt-komercial-essen": {
          subtitle: null,
          overviewText:
            "This project was developed in Essen, Germany. It's a commercial mixed-use object combining wellness, hospitality and event spaces. ArStudio Solutions LLC acted as the executing planning office, including the complete electrical planning.",
          metaScopeValue: "Construction planning, Electrical",
          buttons: [
            { key: "plans", icon: "file", label: "View construction plans", status: "Google Drive", type: "link" },
            { key: "details", icon: "arrow", label: "Open project details", status: "Google Drive", type: "link", primary: true },
            { key: "interior", icon: "sofa", label: "Interior design", status: "In progress", type: "disabled" },
            { key: "electrical", icon: "zap", label: "Electrical planning", status: "In progress", type: "disabled" },
          ],
        },
        kindertagesstaette: {
          subtitle:
            "New construction of a plot for a 4-track kindergarten (Kindertagesstätte)",
          overviewText:
            "New construction of a site for a 4-track kindergarten (Kindertagesstätte). The complete electrical planning was carried out according to German standards (VDE, DIN, DGUV) — from distribution and lighting to fire alarm, safety, data network and emergency / safety lighting.",
          metaScopeValue: "Electrical planning (VDE / DIN)",
          buttons: [
            { key: "view", icon: "arrow", label: "Open project", status: "Google Drive", type: "link", primary: true },
          ],
        },
        "moschee-dortmund": {
          subtitle:
            "Fully integrated planning — architecture, interior and electrical from a single hand",
          overviewText:
            "A holistic project for the Mosque in Dortmund. ArStudio Solutions LLC coordinated and delivered the complete facade visualization and renderings, construction planning, interior design, detail and section planning as well as the entire electrical design — two disciplines, one team.",
          metaScopeValue: "Architecture, Interior & Electrical",
          buttons: [
            { key: "architektur", icon: "file", label: "Open architecture", status: "Google Drive · Facade, Interior, Details, Sections", type: "link", primary: true },
            { key: "elektro", icon: "zap", label: "Open electrical", status: "Google Drive · Electric", type: "link" },
          ],
        },
      },
    },
    legal: {
      impressum: {
        title: "Legal Notice",
        subtitle: "Information according to § 5 TMG (DE)",
        sections: [
          {
            h: "Provider",
            body: [
              "ArStudio Solutions LLC",
              "Owner: Arian Isufi",
              "Rruga 12 Qershori Nr. 144",
              "70000 Ferizaj, Kosovo",
            ],
          },
          {
            h: "Contact",
            body: [
              "Phone: +383 45 813 843",
              "E-mail: info@arstudio360.online",
              "Web: arstudio360.online",
            ],
          },
          {
            h: "Responsible for content",
            body: ["Arian Isufi", "Address as above"],
          },
          {
            h: "Liability for content",
            body: [
              "The contents of this website have been created with the greatest care. However, we cannot guarantee the accuracy, completeness or timeliness of the contents. As a service provider, we are responsible for our own content on these pages according to § 7 (1) TMG under general laws.",
            ],
          },
          {
            h: "Liability for links",
            body: [
              "Our offer contains links to external third-party websites, the content of which we have no influence over. Therefore, we cannot assume any liability for these external contents.",
            ],
          },
          {
            h: "Copyright",
            body: [
              "The contents and works created by the site operators on these pages are subject to copyright. Reproduction, editing, distribution and any type of exploitation outside the limits of copyright require the written consent of the respective author.",
            ],
          },
        ],
      },
      privacy: {
        title: "Privacy Policy",
        subtitle: "Information on processing your data",
        sections: [
          {
            h: "1. Data controller",
            body: [
              "Responsible for data processing on this website:",
              "ArStudio Solutions LLC, Arian Isufi, Rruga 12 Qershori Nr. 144, 70000 Ferizaj, Kosovo. E-mail: info@arstudio360.online.",
            ],
          },
          {
            h: "2. Collection of personal data",
            body: [
              "When you use our contact form, we collect: name, e-mail address, subject and message. This data is stored exclusively to process your request and is not shared with third parties.",
              "Legal basis: Art. 6 (1) lit. b and f GDPR (contract initiation / legitimate interest).",
            ],
          },
          {
            h: "3. Server log files",
            body: [
              "The site provider automatically collects and stores information in server log files (browser type, operating system, referrer URL, hostname, time of the request). This data cannot be assigned to specific persons.",
            ],
          },
          {
            h: "4. Your rights",
            body: [
              "You have the right to information, correction, deletion, restriction of processing, data portability and objection at any time. Please contact: info@arstudio360.online.",
            ],
          },
          {
            h: "5. Storage duration",
            body: [
              "Personal data from inquiries is deleted as soon as it is no longer required for the purpose for which it was collected — at the latest after statutory retention periods have expired.",
            ],
          },
          {
            h: "6. Cookies & analytics",
            body: [
              "This website only uses technically necessary cookies. No marketing or tracking cookies are used that would require explicit consent.",
            ],
          },
        ],
      },
    },
  },
};

export const COMPANY = {
  name: "ArStudio Solutions LLC",
  owner: "Arian Isufi",
  phone: "+383 45 813 843",
  email: "info@arstudio360.online",
  addressLine1: "Rruga 12 Qershori Nr. 144",
  addressLine2: "70000 Ferizaj, Kosovo",
  siteName: "arstudio360.online",
};
